import API from '../api';

export const getOpenedPositions = (params) => API.get(`/api/v1/trading-history/positions?${params}`)

export const getSymbols = () => API.get('/api/v1/trading-history/values')